import { Component, ViewEncapsulation, OnInit, computed, signal } from '@angular/core';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { ChipModule } from 'primeng/chip';
import { IconFieldModule } from 'primeng/iconfield';
import { InputTextModule } from 'primeng/inputtext';
import { InputIconModule } from 'primeng/inputicon';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { HeadingComponent } from '../../../../../shared/components/heading/heading.component';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { SearchMarkets, SearchMarket, SearchReviewerQueryParams, WorkedTogetherResponse, Reviewer, SearchReviewerResponse } from '../people.interface';
import { PeopleService } from '../../../../../shared/services/people.service';
import { constants } from '../../../../../shared/constants/constants';
import { InputSwitchModule } from 'primeng/inputswitch';
import { RatingModule } from 'primeng/rating';
import { ConfirmationDialogService } from '../../../../../shared/services/confirmation-dialog.service';
import { ToastService } from '../../../../../shared/services/toast.service';
import { ReviewerDetailDialogService } from '../../../../../shared/services/reviewer-detail-dialog.service';
import { TooltipModule } from 'primeng/tooltip';
import { UserService } from '../../../../../shared/services/user.service';
import { StorageService } from '../../../../../shared/services/storage.service';
import { EmittersService } from '../../../../../shared/services/emitters.service';
import { Subscription } from 'rxjs';
import { ConfigurationService } from '../../../../../shared/services/configuration.service';
import { PipesModule } from '../../../../../shared/pipes/pipes.module';
import { HelperService } from '../../../../../shared/services/helper.service';
import { ClientPortalService } from '../../../../../shared/services/client-portal.service';
import { ClientPortalWorkedTogetherReviewer } from '../../../../../shared/interfaces/client-portal.interface';
import { ClientReviewerProfileComponent } from '../../../../../shared/components/client-reviewer-profile/client-reviewer-profile.component';
@Component({
  selector: 'app-worked-together',
  standalone: true,
  imports: [DropdownModule, ButtonModule, FormsModule, RatingModule, ChipModule, IconFieldModule, InputIconModule, InputSwitchModule, HeadingComponent, InputTextModule, TableModule, TagModule, CommonModule, TooltipModule, PipesModule],
  templateUrl: './worked-together.component.html',
  styleUrl: './worked-together.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class WorkedTogetherComponent implements OnInit {
  headingButton = {
    url: '/client/people/invite-candidate',
    label: 'INVITE CANDIDATE',
    colorClass: 'button-bg-pink',
    icon: 'x'
  };
  pendingCandidateButton = {
    url: '/client/people/pending-candidates',
    label: 'PENDING CANDIDATES',
    icon: 'x'
  }
  sortings: any = [];
  userFilters: any = [];
  selectedSortOrder = {
    name: '',
    value: ''
  }
  reviewerCount: number = 0;
  searchMarkets: any = [];
  reviewers: Reviewer[] = [];
  selectedUserFilter = {
    name: 'Active', value: 'active'
  };
  searchText = '';
  userObject: any;
  displaySearchTextChip = false;
  isPwcEnabled = false;
  searchTextDisplaying = '';
  searchMarketsSelecterEmitter: Subscription | undefined;
  /**
   * MP-5754 client mode, derived once from the session role. The list comes
   * from `client-portal/workedTogether` (derived from positions, not the
   * firm's curated list), is filtered and paged in the browser, has no
   * remove action, and a name opens the redacted profile card. Every firm
   * endpoint this screen otherwise touches answers 403 for a CLIENT.
   */
  readonly clientMode = signal(false);
  /** Client mode only: the full portal list; the table pages the filtered view. */
  readonly portalReviewers = signal<ClientPortalWorkedTogetherReviewer[]>([]);
  /** Client mode only: the applied (entered) search text; the input binds the draft. */
  readonly portalSearchText = signal('');
  readonly filteredPortalReviewers = computed(() => {
    const text = this.portalSearchText().trim().toLowerCase();
    if (!text) {
      return this.portalReviewers();
    }
    return this.portalReviewers().filter((reviewer) =>
      `${reviewer.firstName || ''} ${reviewer.lastName || ''} ${reviewer.preferredFirstName || ''}`.toLowerCase().includes(text));
  });
  private readonly portalProfileRef = signal<DynamicDialogRef | undefined>(undefined);

  constructor(private route: ActivatedRoute, private peopleService: PeopleService, private configurationService: ConfigurationService,
    private confirmationDialogService: ConfirmationDialogService, private toast: ToastService,private reviewerDetailDialogService:ReviewerDetailDialogService,
    public helperService: HelperService, private userService: UserService, private storageService:StorageService, private emitterService:EmittersService,
    private clientPortalService: ClientPortalService, private dialogService: DialogService) {
    this.clientMode.set(this.clientPortalService.isClientPortalUser());
  }

  ngOnInit() {
    this.isPwcEnabled = this.configurationService.getPwcFlag();
    this.userObject = this.userService.getSessionUser();
    if (this.clientMode()) {
      this.getPortalReviewers();
      return;
    }
    this.getPendingReviewers();
    
    this.sortings = constants.sortingFilter;
    this.userFilters = [
      { name: 'Active', value: 'active' },
      { name: 'Inactive', value: 'inactive' },
      { name: 'All', value: 'all' },

    ];
    this.subscribeEvent();
  }
  subscribeEvent(): void{
  
    this.searchMarketsSelecterEmitter = this.emitterService.searchMarketSelectorEmitter.subscribe(()=>{
      this.getReviewers({ first: 0, rows: 10 });
    });
  }
  onSortChange(event: any) {
    this.selectedSortOrder = event.value;
    this.getReviewers({ first: 0, rows: 10 });
  }
  onFilterChange(event: any) {
    this.selectedUserFilter = event.value;
    this.getReviewers({ first: 0, rows: 10 });
  }
  getSearchMarkets() {
    return this.storageService.getSelectedSearchMarkets().join(',');
  }
  onEnter($event: any) {
    if ($event.keyCode === 13) {
      this.onSearchClick();
    }
  }
  onSearchClick() {
      this.searchTextDisplaying = this.searchText.slice(0);
      this.displaySearchTextChip = this.searchText === '' ? false : true;
      if (this.clientMode()) {
        this.portalSearchText.set(this.searchText);
        return;
      }
      this.getReviewers({ first: 0, rows: 10 });
  }
  onRemoveChip(type: string) {
    if (type === 'sortOrder') {
      this.selectedSortOrder = {
        name: '',
        value: ''
      };
    } else if (type === 'userFilter') {
      this.selectedUserFilter = {
        name: '',
        value: ''
      };
    } else {
      this.searchText = '';
      this.searchTextDisplaying = '';
      this.displaySearchTextChip = false;
    }
    if (this.clientMode()) {
      this.portalSearchText.set(this.searchText);
      return;
    }
    this.getReviewers({ first: 0, rows: 10 });
  }

  /** Client mode: one unpaged call; the backend already sorts by last name, then first name. */
  getPortalReviewers(): void {
    this.clientPortalService.getWorkedTogether().subscribe({
      next: (reviewers: ClientPortalWorkedTogetherReviewer[]) => this.portalReviewers.set(reviewers || []),
      error: () => this.portalReviewers.set([])
    });
  }

  /** Tooltip text for the Projects Together count: the group's project code names. */
  portalProjectNames(reviewer: ClientPortalWorkedTogetherReviewer): string {
    return (reviewer.projects || []).map((project) => project.codeName).filter((name) => !!name).join(', ');
  }

  /**
   * Client mode: the redacted profile card (MP-5754 item 3). The full
   * ReviewerProfileComponent is not reused: its template hard-wires email,
   * phone, address, pay rates, favorites, documents and notes, and its init
   * fires six firm endpoints that answer 403 for a CLIENT.
   */
  openPortalReviewerProfile(reviewerId: string): void {
    this.portalProfileRef.set(this.dialogService.open(ClientReviewerProfileComponent, {
      data: { reviewerId },
      header: 'Reviewer profile',
      width: '60vw',
      contentStyle: { overflow: 'auto' },
      breakpoints: {
        '960px': '75vw',
        '640px': '90vw'
      }
    }));
  }
  getReviewers(event?: any) {
    const offset = event.first;
    const limit = event.rows;
    const queryParams: SearchReviewerQueryParams = {
      sortOrder: constants.sortingOrder.descending,
      skip: offset,
      take: limit,
      markets: this.getSearchMarkets(),
      userStatus: 'active',
    };

    if (this.selectedSortOrder.value) {
      queryParams.sortBy = this.selectedSortOrder.value;
      if(queryParams.sortBy === 'firstName'){
        queryParams.sortOrder = constants.sortingOrder.ascending;
      }
    }
    if (this.selectedUserFilter.value) {
      queryParams.userStatus = this.selectedUserFilter.value;
    }
    if (this.searchText) {
      queryParams.search = this.searchText;
    }
    this.peopleService.getWorkedTogetherList(queryParams).subscribe((response: WorkedTogetherResponse) => {
      this.reviewers = response.reviewers;
      this.reviewerCount = response.totalReviewersCount;
    })
  }
  removeFromWorkTogetherList($event: Event, reviewer: Reviewer) {
    const mesg = `You are about to remove ${reviewer.firstName} ${reviewer.lastName} from Worked Together list. Are you sure?`
    this.confirmationDialogService.confirm({
      target: $event.target as EventTarget,
      message: mesg,
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: "none",
      rejectIcon: "none",
      rejectButtonStyleClass: "p-button-text",
      accept: () => {
        this.peopleService.removeFromWorkedTogetherList(reviewer._id).subscribe((response: any) => {
          this.getReviewers({ first: 0, rows: 10 });
          this.toast.showSuccess('Removed from work together list')
        })
      }
    });

  }

  openReviewerDialog(id:string){
    if (this.clientMode()) {
      this.openPortalReviewerProfile(id);
      return;
    }
    this.reviewerDetailDialogService.openDialog(id);
  }
  ngOnDestroy(): void {
    this.searchMarketsSelecterEmitter && this.searchMarketsSelecterEmitter.unsubscribe();
    this.portalProfileRef()?.close();
  }
  getPendingReviewers() {
    const offset = 0;
    const limit = 10;
    const queryParams: SearchReviewerQueryParams = {
      sortOrder: constants.sortingOrder.descending,
      offset: offset,
      limit: limit,
      searchOn: 'all',
    };
    this.peopleService.getPendingCandidateList(queryParams, this.userService.getUserFirmId()).subscribe((response: SearchReviewerResponse) => {
      this.pendingCandidateButton.label = `PENDING CANDIDATES (${response.count})`;
    })
  }
}